/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  connect
} from 'react-redux';
import { Field } from '@progress/kendo-react-form';
import { CustomDropDownInputUnwrapped } from 'components/shared/form/custom_dropdown_input';
import { CustomInput } from 'components/shared/form/custom_input';
import { RadioInput } from 'components/shared/form/radio_input';
import content from 'utility/token_helper';
import { Error } from '@progress/kendo-react-labels';
import { CustomTextarea } from 'components/shared/form/custom_textarea';
import { PhysicianType } from 'utility/enumerations';

function RegistrationCheck(props) {
  const {
    errors
  } = props.formRenderProps;

  const userActionForm = (
    <div>
      <Field
        id="profession"
        name="profession"
        dropDownValues={props.professions}
        label={content('physician', 'mqa-check-profession', props.categoryClientContent)}
        component={CustomDropDownInputUnwrapped}
        aria-label="Profession"
      />
      <Error>{errors?.requiredProfession}</Error>
      <Field
        id="licenseNumber"
        name="licenseNumber"
        label={content('physician', 'mqa-check-license-number', props.categoryClientContent)}
        component={CustomInput}
        maxLength={32}
        aria-label="License Number"
      />
      <Error>{errors?.requiredLicenseNumber}</Error>
      <Error>{errors?.formatLicenseNumber}</Error>
      <Field
        id="justification"
        name="justification"
        label={content('physician', 'mqa-check-justification', props.categoryClientContent)}
        component={CustomTextarea}
        max={255}
        aria-label="justification"
      />
      <Error>{errors?.requiredJustification}</Error>
      <Field
        id="physicianType"
        name="physicianType"
        label="Physician Type"
        component={RadioInput}
        layout="vertical"
        leftAlign
        data={[
          { label: 'Physician', value: PhysicianType.Physician },
          { label: 'Medical Director', value: PhysicianType.MedicalDirector },
        ]}
        aria-label="Physician Type"
      />
    </div>
  );

  return (
    <div>
      {userActionForm}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    categoryClientContent: state.content.categoryClientContent,
  };
}
export default connect(mapStateToProps)(RegistrationCheck);
